import React, { useEffect, useState, useContext, useMemo, MouseEventHandler } from 'react';
import { Table, TableCell, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  GetKindNoNameSetType,
  GetNameItemSetType,
  GetLogIntSetType,
  GetmulItems,
  GetDataUnitType,
  PLCcollectSettingType,
  KIND_NO_NAME_SET,
  NAME_ITEM_SET,
  LOG_INT_SET,
  MulDataType,
  DATA_UNIT,
  GetConanMeasureName,
} from './CollectSettingDefine';
import { NAME_DEV_SET, GetNameDevSetList } from '../../../../function/NameDevSetModel';
import dayjs from 'dayjs';

import { useTranslation, UseTranslationResponse } from 'react-i18next';
import StackCell, { CellSizeContainer } from '../../../atoms/Cell/StackCell';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../../atoms/ComboBox/ItemComboBoxStr';
import { TFunction } from 'i18next';
import JudgeSettingDialog, { JudgeSettingDialogResponse } from '../JudgeSetting/JudgeSettingDialog';
import { useModal } from '../../../../function/useModal';
import CollectSettingItemDialog, { CollectSettingItemDialogResponse } from './CollectSettingItemDialog';

import { SpeedKind, MeasureHighKind } from '../../../../Constant';

type CollectGridBodyProps = {
  plcSettingList: PLCcollectSettingType[];
  isDispPLC: boolean;
  isOrderDevice: boolean;
  isIoT:boolean;
  update: (target: PLCcollectSettingType, index: number) => void;
  updateStartTime: (devIndex: string, startTime: Date) => void;
  updateMotorSensor: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateRotClc: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
};

const useStyles = makeStyles(
  createStyles({
    '@global': {
      '.MuiTableCell-body': { color: 'inherit' },
    },
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    fixColumn: {
      borderWidth: '0px',
      outlineWidth: '1px',
      outlineColor: '#dcdcdc',
      outlineStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      position: 'sticky',
      zIndex: 10,
      backgroundColor: 'white',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      borderCollapse: `collapse`,
      zIndex: 0,
    },
    tableTdLowPass: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      background: '#1da81dff',
      borderStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      borderCollapse: `collapse`,
      zIndex: 0,
    },
    table_no_border_td: {
      borderTop: '0px',
      borderBottom: '0px',
      borderLeft: '0px',
      borderRight: '1px',
      borderRightStyle: 'solid',
      borderRightColor: '#dcdcdc',
      padding: '0px',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    textAlignRightCell: {
      textAlign: 'right',
    },
    textAlignCenterCell: {
      textAlign: 'center',
    },
    labelStyle: {
      fontSize: '12px',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
      padding: '0px',
      backgroundColor: 'transparent',
    },
    selectRow: {
      background: '#7fffd4',
    },
  })
);

const CollectGridBody: React.FC<CollectGridBodyProps> = (props: CollectGridBodyProps) => {
  //console.debug(['CollectGridBody()', props]);
  const { t } = useTranslation();
  const classes = useStyles();
  // const [plcSettingList, setPlcSettingList] = React.useState<PLCcollectSettingType[]>([]);
  const [kindNoNameList, setKindNoNameList] = React.useState<KIND_NO_NAME_SET[]>([]);
  const [nameDevList, setNameDevList] = React.useState<NAME_DEV_SET[]>([]);
  const [nameItemList, setNameItemList] = React.useState<NAME_ITEM_SET[]>([]);
  const [logIntList, setLogIntList] = React.useState<LOG_INT_SET[]>([]);
  const [mulList, setMULList] = React.useState<MulDataType[]>([]);
  const [dataUnitList, setDataUnitList] = React.useState<DATA_UNIT[]>([]);
  const [measCombos, setMeasCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [devCombos, setDevCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [itemCombos, setItemCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [mulCombos, setMulCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [unitCombos, setUnitCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [logIntCombos, setLogIntCombos] = useState<ComboBoxItemTypeS[]>([]);
  const avgCombos: ComboBoxItemType[] = [
    { index: 0, name: t('CollectGridBody.加算平均', '加算平均') },
    { index: 1, name: t('CollectGridBody.指数平均', '指数平均') },
    { index: 2, name: t('CollectGridBody.ピークホールド', 'ピークホールド') },
  ];
  const [plcNo, setPlcNo] = useState<number>(0);
  const [aiCard, setAiCard] = useState<number>(0);
  const [aiCh, setAiCh] = useState<number>(0);
  const [cursorIndex, setCursorIndex] = useState<number>(-1);

  console.debug('MeasureGridBody');
  console.debug(props.plcSettingList.length);

  useEffect(() => {
    var a = GetKindNoNameSetType();
    var b = GetNameDevSetList();
    var c = GetNameItemSetType();
    var d = GetLogIntSetType();
    var e = GetmulItems();
    var f = GetDataUnitType();

    Promise.all([a, b, c, d, e, f]).then((ret) => {
      //console.debug(['Promise.all : ret', ret]);
      console.debug(ret[0]);
      console.debug(ret[1]);
      console.debug(ret[2]);
      console.debug(ret[3]);
      console.debug(ret[4]);
      console.debug(ret[5]);

      setKindNoNameList(ret[0]);
      setNameDevList(ret[1]);
      setNameItemList(ret[2]);
      setLogIntList(ret[3]);
      setMULList(ret[4]);
      setDataUnitList(ret[5]);

      //振動Row取得
      //コナンエアの場合SPEED２の振動と同じ名前を付ける
      let conaMesName = GetConanMeasureName(ret[0]);
      setMeasCombos(
        ret[0].map<ComboBoxItemTypeS>((ci) => {
          if (ci.SPEED === SpeedKind.SPEED_CONAN) {
            return { key: `${ci.NAME_NO}_${ci.SPEED}`, name: conaMesName };
          } else {
            return { key: `${ci.NAME_NO}_${ci.SPEED}`, name: ci.MES_NAME };
          }
        })
      );
      //機器番号 実装のみ選択可
      setDevCombos(
        ret[1]
          .filter((ci) => ci.EST === 1)
          .map<ComboBoxItemTypeS>((ci) => {
            return { key: `${ci.DEV_INDEX}`, name: ci.DEV_NO };
          })
          .concat({ key: '0', name: '-' })
      );
      //項目名称 実装のみ選択可
      setItemCombos(
        ret[2]
          .filter((ci) => ci.EST === 1)
          .map<ComboBoxItemTypeS>((ci) => {
            return { key: `${ci.ITM_NAME_NO}`, name: ci.ITM_NAME };
          })
      );
      setLogIntCombos(
        ret[3].map<ComboBoxItemTypeS>((ci) => {
          return { key: `${ci.LOG_INT}`, name: ci.DSP_STR, tag: ci };
        })
      );
      setMulCombos(
        ret[4].map<ComboBoxItemTypeS>((ci) => {
          return { key: `${ci.code}`, name: ci.value };
        })
      );
      setUnitCombos(
        ret[5].map<ComboBoxItemTypeS>((ci) => {
          return { key: ci.UNIT_STR, name: ci.UNIT_STR };
        })
      );
    });
  }, []);

  const updateCursor = (index: number) => {
    setCursorIndex(index);
  };

  // <!-- ItemCheckBox value={props.item.IsExecute} label={t('CollectGridBody.実行','実行')} onChangeEvent={(e) => onChangeCheckBox(e, props.item)} /-->
  return (
    <React.Fragment>
      {props.plcSettingList?.map((row, idx) => (
        <CollectGridRow
          key={`${row.PLCNo}_${row.AICardNo}_${row.ChannelNo}`}
          item={row}
          index={idx}
          selectIndex={cursorIndex}
          isDispPLC={props.isDispPLC}
          isIoT={props.isIoT}
          kindNoNameList={kindNoNameList}
          nameDevList={nameDevList}
          nameItemList={nameItemList}
          logIntList={logIntList}
          mulList={mulList}
          dataUnitList={dataUnitList}
          measCombos={measCombos}
          devCombos={devCombos}
          itemCombos={itemCombos}
          mulCombos={mulCombos}
          unitCombos={unitCombos}
          logIntCombos={logIntCombos}
          avgCombos={avgCombos}
          t={t}
          update={props.update}
          updateStartTime={props.updateStartTime}
          updateMotorSensor={props.updateMotorSensor}
          updateRotClc={props.updateRotClc}
          updateCursor={updateCursor}
        />
      ))}
    </React.Fragment>
  );
};

type CollectGridRowProps = {
  item: PLCcollectSettingType;
  index: number;
  selectIndex: number;
  isDispPLC: boolean;
  isIoT: boolean;
  kindNoNameList: KIND_NO_NAME_SET[];
  nameDevList: NAME_DEV_SET[];
  nameItemList: NAME_ITEM_SET[];
  logIntList: LOG_INT_SET[];
  mulList: MulDataType[];
  dataUnitList: DATA_UNIT[];
  measCombos: ComboBoxItemTypeS[];
  devCombos: ComboBoxItemTypeS[];
  itemCombos: ComboBoxItemTypeS[];
  mulCombos: ComboBoxItemTypeS[];
  unitCombos: ComboBoxItemTypeS[];
  logIntCombos: ComboBoxItemTypeS[];
  avgCombos: ComboBoxItemType[];
  t: TFunction;
  update: (target: PLCcollectSettingType, index: number) => void;
  updateStartTime: (devIndex: string, startTime: Date) => void;
  updateMotorSensor: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateRotClc: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateCursor: (index: number) => void;
};

const CollectGridRow: React.FC<CollectGridRowProps> = (props) => {
  //console.debug(['CollectGridRow()', props]);
  const classes = useStyles();

  const [forceUpd, setForceUpd] = useState<number>(0);
  const [item, setItem] = useState<PLCcollectSettingType>(props.item);
  const [selectIndex, setSelectIndex] = useState<number>(-1);

  const cnt = new CellSizeContainer();

  useEffect(() => {
    //    setStartTime(dayjs(props.item.LoggingStartTime).format('YYYY-MM-DD HH:mm:ss'));
  }, [props.item.LoggingStartTime]);

  useEffect(() => {
    console.log([`CollectGridRow - ${props.item.PLCNo}`, props.item]);
  }, [props.item]);

  const [flgEdit, editDlg] = useModal<CollectSettingItemDialogResponse>();
  const editdlgElem = flgEdit ? (
    <CollectSettingItemDialog
      dialog={editDlg}
      target={item}
      index={props.index}
      measCombos={props.measCombos}
      devCombos={props.devCombos}
      itemCombos={props.itemCombos}
      mulCombos={props.mulCombos}
      unitCombos={props.unitCombos}
      logIntCombos={props.logIntCombos}
      avgCombos={props.avgCombos}
      kindNoNameList={props.kindNoNameList}
      nameDevList={props.nameDevList}
      nameItemList={props.nameItemList}
      logIntList={props.logIntList}
      mulList={props.mulList}
      dataUnitList={props.dataUnitList}
      updateMotorSensor={props.updateMotorSensor}
      updateRotClc={props.updateRotClc}
      isIoT={props.isIoT}
    />
  ) : null;

  const doubleClick = () => {
    console.log('mouse dbl click');
    editDlg.open().apply((resp) => {
      props.update(resp.result, props.index);
      props.updateStartTime(resp.result.MachineIndex, resp.result.LoggingStartTime);
      setItem(resp.result);
    });
  };

  const selectRow = () => {
    props.updateCursor(props.index);
  };

  const lineAttr = props.index == props.selectIndex ? classes.selectRow : '';

  const fix1 = (
    <StackCell
      className={classes.fixColumn + ' ' + lineAttr}
      container={cnt}
      width={80}
      top={-1}
      onClick={selectRow}
      onDoubleClick={doubleClick}
    >
      {props.item.PLCNo}
    </StackCell>
  );
  const fix2 = (
    <StackCell
      className={classes.fixColumn + ' ' + lineAttr}
      container={cnt}
      width={160}
      top={-1}
      onClick={selectRow}
      onDoubleClick={doubleClick}
    >
      {props.item.UnitName}
    </StackCell>
  );
  const fix3 = (
    <StackCell
      className={classes.fixColumn + ' ' + lineAttr}
      container={cnt}
      width={80}
      top={-1}
      onClick={selectRow}
      onDoubleClick={doubleClick}
    >
      {props.item.AICardNo}
    </StackCell>
  );
  const fix4 = (
    <StackCell
      className={classes.fixColumn + ' ' + lineAttr}
      container={cnt}
      width={80}
      top={-1}
      onClick={selectRow}
      onDoubleClick={doubleClick}
    >
      {props.item.ChannelNo}
    </StackCell>
  );

  const colDig = (
    <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
      <Table>
        <TableRow>
          <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
            {item.NameNo != 0 ? item.DigitalValueUpper : ''}
          </TableCell>
          <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
            {item.NameNo != 0 ? item.DigitalValueLower : ''}
          </TableCell>
        </TableRow>
      </Table>
    </TableCell>
  );
  const colEng = (
    <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
      <Table>
        <TableRow>
          <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
            {item.NameNo != 0 ? item.EngineeringValueUpper : ''}
          </TableCell>
          <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
            {item.NameNo != 0 ? item.EngineeringValueLower : ''}
          </TableCell>
        </TableRow>
      </Table>
    </TableCell>
  );
  const colMul = (
    <TableCell
      className={classes.tableTd + ' ' + classes.textAlignRightCell}
      onClick={selectRow}
      onDoubleClick={doubleClick}
    >
      {item.NameNo != 0 ? props.mulCombos.find((ml) => ml.key == item.Mul.toString())?.name : ''}
    </TableCell>
  );

  return (
    <>
      <TableRow className={lineAttr}>
        {/**No */}
        <StackCell
          className={classes.fixColumn + ' ' + classes.textAlignCenterCell + ' ' + lineAttr}
          container={cnt}
          width={80}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.index + 1}
        </StackCell>
        {/**実行 */}
        <StackCell
          className={classes.fixColumn + ' ' + classes.textAlignCenterCell + ' ' + lineAttr}
          container={cnt}
          width={80}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {/* <input type="checkbox" checked={item.IsExecute} defaultChecked={item.IsExecute} /> */}
          <div>{item.IsExecute == true ? '✔' : ''}</div>
        </StackCell>
        {props.isDispPLC ? fix1 : null}
        {props.isDispPLC ? fix2 : null}
        {props.isDispPLC ? fix3 : null}
        {props.isDispPLC ? fix4 : null}
        {/**計測種別 */}
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={160}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.measCombos.find((d) => d.key == `${item.NameNo}_${item.Speed}`)?.name}
        </StackCell>
        {/** */}
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={160}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.NameNo != 0 ? props.devCombos.find((d) => d.key === item.MachineIndex)?.name : ''}
        </StackCell>
        {/**機器番号 */}
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={160}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.NameNo != 0 ? props.nameDevList.find((it) => it.DEV_INDEX === Number(item.MachineIndex))?.DEV_NAME : ''}
        </StackCell>
        {/**機器名称 */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0 ? props.itemCombos.find((it) => it.key === item.ItemNameNo.toString())?.name : ''}
        </TableCell>
        {/**項目名称 */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0
            ? props.logIntCombos.find((lg) => {
                let v = lg.tag as LOG_INT_SET;
                if (v) {
                  return v.SPEED === item.Speed && v.LOG_INT === item.LoggingPeriodMinute;
                } else {
                  return false;
                }
              })?.name
            : ''}
        </TableCell>
        {/**ロギング時間 */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo == 0 || item.LoggingStartTime == undefined
            ? ''
            : dayjs(item.LoggingStartTime).format('YYYY-MM-DD HH:mm:ss')}
        </TableCell>
        {/**単位 */}
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.NameNo != 0 ? props.unitCombos.find((un) => un.key === item.UnitSymbol)?.name : ''}
        </TableCell>
        {/* <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell} onDoubleClick={doubleClick}>
          {props.t('CollectGridBody.変更', '変更')}
        </TableCell> */}
        {/**アベレージング処理 */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0 ? props.avgCombos.find((av) => av.index === item.AvgPrc)?.name : ''}
        </TableCell>
        {/* <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.EnvSav == true ? '✔' : ''}</div>
          <input type="checkbox" checked={item.EnvSav} defaultChecked={item.EnvSav} />
        </TableCell> */}
        {/**モータ起動状態検出センサ指定 */}
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.StartDet == 1 ? '✔' : ''}</div>
          {/* <input type="checkbox" checked={item.StartDet == 1} defaultChecked={item.StartDet === 1} /> */}
        </TableCell>
        {/**回転周波数算出センサ */}
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.RotClc == true ? '✔' : ''}</div>
          {/* <input type="checkbox" checked={item.RotClc} defaultChecked={item.RotClc} /> */}
        </TableCell>
        {props.isDispPLC ? colDig : null}
        {props.isDispPLC ? colEng : null}
        {props.isDispPLC ? colMul : null}
        {/**ローパスフィルタ */}
        <TableCell 
          className={classes.tableTdLowPass+ ' ' + classes.textAlignCenterCell + ' ' +lineAttr}
          onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0 && item.LowPassFlg !== null && item.LowPassFlg ? 'ON' : 'OFF'}
        </TableCell>
      </TableRow>
      {editdlgElem}
    </>
  );
};

export default CollectGridBody;
